import React from 'react'

export default function HomeSidebarItem({ data }) {
    return (
        <div className='flex items-center py-4 border-b border-transparentWhite'>
            {
                // if data is post open other website url
                data?.post ?
                    <a href={data?.post} target='_blank' rel="noreferrer" >
                        <div className='relative min-h-[5.5rem!important] min-w-[5.69rem!important] max-h-[5.5rem!important] max-w-[5.69rem!important] cursor-pointer'>
                            <img src={data?.img} alt={data.section} className="min-h-[5.5rem!important] min-w-[5.69rem!important] max-h-[5.5rem!important] max-w-[5.69rem!important] object-cover rounded-[0.313rem]" />
                            <div className='absolute w-full h-full top-0 left-0 flex justify-center items-center bg-sidebarItemBg '>
                                <img src={`/images/icons/post.svg`} alt="play" className='w-[2.13rem] h-[2.13rem]' />
                            </div>
                        </div>
                    </a> :
                    // if data is other then post open popup
                    // TODO add popup functional
                    <div className='relative min-h-[5.5rem!important] min-w-[5.69rem!important] max-h-[5.5rem!important] max-w-[5.69rem!important] cursor-pointer'>
                        <img src={data?.img} alt={data.section} className="min-h-[5.5rem!important] min-w-[5.69rem!important] max-h-[5.5rem!important] max-w-[5.69rem!important] object-cover rounded-[0.313rem]" />
                        <div className='absolute w-full h-full top-0 left-0 flex justify-center items-center bg-sidebarItemBg '>
                            {
                                data?.video || data?.audio ?

                                    <img src={`/images/icons/play.svg`} alt="play" className='w-[2.13rem] h-[2.13rem]' />
                                    :
                                    <img src={`/images/icons/image-icon.svg`} alt="play" className='w-[2.13rem] h-[2.13rem]' />

                            }
                        </div>
                    </div>
            }
            {/* <div className='relative min-h-[5.5rem!important] min-w-[5.69rem!important] max-h-[5.5rem!important] max-w-[5.69rem!important]cursor-pointer'>
                <img src={data?.img} alt={data.section} className="min-h-[5.5rem!important] min-w-[5.69rem!important] max-h-[5.5rem!important] max-w-[5.69rem!important] object-cover rounded-[0.313rem]" />
                <div className='absolute w-full h-full top-0 left-0 flex justify-center items-center bg-sidebarItemBg '>
                    <img src={`/images/icons/play.svg`} alt="play" className='w-[2.13rem] h-[2.13rem]' />
                </div>
            </div> */}
            <div className='font-dropdownFont font-medium tracking-wider text-xs leading-5 pl-4'>
                <div>Section</div>
                <div className='text-transparentWhite45'>{data.section}</div>
                <div>Category</div>
                <div className='text-transparentWhite45'>{data.category}</div>
            </div>
        </div>
    )
}
